<template>
<LayoutContainer>
    <div slot="col1">
        This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1.  
    </div>
    <!-- <div slot="col2">
        <LayoutContainer></LayoutContainer>
    </div> -->
</LayoutContainer>
</template>

<script>
import LayoutContainer from '@/ui-elements/LayoutContainer'

export default {
    data() {
        return {
        
        }
    },

    components: {
        LayoutContainer
    },
    
    props: {
        item: Object,
    },

    computed: {
        property1() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    },

    // watch: {
    //     item: {
    //         handler: function (val, oldVal) { /* ... */ },
    //         deep: true
    //     },
    // }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// LayoutPage.vue?0f6032a9